/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundPictureDetailNodataVo } from './InboundPictureDetailNodataVo';
import {
    InboundPictureDetailNodataVoFromJSON,
    InboundPictureDetailNodataVoFromJSONTyped,
    InboundPictureDetailNodataVoToJSON,
    InboundPictureDetailNodataVoToJSONTyped,
} from './InboundPictureDetailNodataVo';
import type { ParcelImgVo } from './ParcelImgVo';
import {
    ParcelImgVoFromJSON,
    ParcelImgVoFromJSONTyped,
    ParcelImgVoToJSON,
    ParcelImgVoToJSONTyped,
} from './ParcelImgVo';
import type { InboundPictureDetailOrderInfoVo } from './InboundPictureDetailOrderInfoVo';
import {
    InboundPictureDetailOrderInfoVoFromJSON,
    InboundPictureDetailOrderInfoVoFromJSONTyped,
    InboundPictureDetailOrderInfoVoToJSON,
    InboundPictureDetailOrderInfoVoToJSONTyped,
} from './InboundPictureDetailOrderInfoVo';
import type { InboundPictureDetailGoodsInfoVo } from './InboundPictureDetailGoodsInfoVo';
import {
    InboundPictureDetailGoodsInfoVoFromJSON,
    InboundPictureDetailGoodsInfoVoFromJSONTyped,
    InboundPictureDetailGoodsInfoVoToJSON,
    InboundPictureDetailGoodsInfoVoToJSONTyped,
} from './InboundPictureDetailGoodsInfoVo';

/**
 * 
 * @export
 * @interface OrderInfoForInboundPictureVo
 */
export interface OrderInfoForInboundPictureVo {
    /**
     * 快递单id
     * @type {number}
     * @memberof OrderInfoForInboundPictureVo
     */
    parcelId?: number;
    /**
     * 
     * @type {InboundPictureDetailNodataVo}
     * @memberof OrderInfoForInboundPictureVo
     */
    orderInfoForInboundPictureNoData?: InboundPictureDetailNodataVo;
    /**
     * 订单信息列表
     * @type {Array<InboundPictureDetailOrderInfoVo>}
     * @memberof OrderInfoForInboundPictureVo
     */
    orderInfoList?: Array<InboundPictureDetailOrderInfoVo>;
    /**
     * 商品信息列表
     * @type {Array<InboundPictureDetailGoodsInfoVo>}
     * @memberof OrderInfoForInboundPictureVo
     */
    goodsInfoList?: Array<InboundPictureDetailGoodsInfoVo>;
    /**
     * 快递图片列表
     * @type {Array<ParcelImgVo>}
     * @memberof OrderInfoForInboundPictureVo
     */
    parcelImgList?: Array<ParcelImgVo>;
}

/**
 * Check if a given object implements the OrderInfoForInboundPictureVo interface.
 */
export function instanceOfOrderInfoForInboundPictureVo(value: object): value is OrderInfoForInboundPictureVo {
    return true;
}

export function OrderInfoForInboundPictureVoFromJSON(json: any): OrderInfoForInboundPictureVo {
    return OrderInfoForInboundPictureVoFromJSONTyped(json, false);
}

export function OrderInfoForInboundPictureVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForInboundPictureVo {
    if (json == null) {
        return json;
    }
    return {
        
        'parcelId': json['parcelId'] == null ? undefined : json['parcelId'],
        'orderInfoForInboundPictureNoData': json['orderInfoForInboundPictureNoData'] == null ? undefined : InboundPictureDetailNodataVoFromJSON(json['orderInfoForInboundPictureNoData']),
        'orderInfoList': json['orderInfoList'] == null ? undefined : ((json['orderInfoList'] as Array<any>).map(InboundPictureDetailOrderInfoVoFromJSON)),
        'goodsInfoList': json['goodsInfoList'] == null ? undefined : ((json['goodsInfoList'] as Array<any>).map(InboundPictureDetailGoodsInfoVoFromJSON)),
        'parcelImgList': json['parcelImgList'] == null ? undefined : ((json['parcelImgList'] as Array<any>).map(ParcelImgVoFromJSON)),
    };
}

export function OrderInfoForInboundPictureVoToJSON(json: any): OrderInfoForInboundPictureVo {
    return OrderInfoForInboundPictureVoToJSONTyped(json, false);
}

export function OrderInfoForInboundPictureVoToJSONTyped(value?: OrderInfoForInboundPictureVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parcelId': value['parcelId'],
        'orderInfoForInboundPictureNoData': InboundPictureDetailNodataVoToJSON(value['orderInfoForInboundPictureNoData']),
        'orderInfoList': value['orderInfoList'] == null ? undefined : ((value['orderInfoList'] as Array<any>).map(InboundPictureDetailOrderInfoVoToJSON)),
        'goodsInfoList': value['goodsInfoList'] == null ? undefined : ((value['goodsInfoList'] as Array<any>).map(InboundPictureDetailGoodsInfoVoToJSON)),
        'parcelImgList': value['parcelImgList'] == null ? undefined : ((value['parcelImgList'] as Array<any>).map(ParcelImgVoToJSON)),
    };
}

